import { DelegateDataSource, Filter, IDataSource, TokenChunkRequest } from '@elderbyte/ngx-starter'
import { filter, map, mergeMap, of } from 'rxjs'
import { WorkBatchPackagesService } from '../../../work-batch-packages.service'
import { truthyPredicate } from '../../../../functional.util'
import { Package } from '../package'
import { PackageFilterBuilder } from '../package-filter-builder'
import { WorkBatchPackagesFilterBuilder } from './work-batch-package-filter-builder'

export class WorkBatchPackagesDataSourceBuilder {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(private service: WorkBatchPackagesService) {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public buildDataSource(): IDataSource<Package> {
    return DelegateDataSource.continuableFetcher((tokenChunkRequest: TokenChunkRequest) => {
      const filters = tokenChunkRequest.filters
      if (filters.length > 1) {
        throw Error(`Unexpected filters: ${filters}`)
      }
      const workBatchId = toWorkBatchId(filters)
      const copy = { ...tokenChunkRequest }
      delete copy.filters // convert to path param request without filters
      return of(workBatchId).pipe(
        filter(truthyPredicate),
        map((workBatchId) => <string>workBatchId), // known single value filter
        mergeMap((workBatchId) => this.service.fetchWorkBatchPackages(workBatchId, copy))
      )
    })
  }
}

function toWorkBatchId(filters: Filter[]): string | string[] | undefined {
  const workBatchKey = WorkBatchPackagesFilterBuilder.WORK_BATCH_ID
  return filters.find((filter) => filter.key === workBatchKey)?.value
}
